import NeptuneElement from '../../NeptuneElement.js';

class Output extends NeptuneElement {

    templateMarkup = `
        <output>
            <slot name="value"></slot>
        </output>
    `;

    componentCssUrl = '/src/components/form/output/output.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }
}

customElements.define('neptune-output', Output);
export default Output;
